<template>
  <ProjectManagementLandingPage />
</template>
  
  <script>
  import ProjectManagementLandingPage from '@/ProjectManagementComponents/ProjectManagementLandingPage.vue';
  
  export default {
    name: 'ProjectManagement',
    components: {
      ProjectManagementLandingPage
    }
  };
  </script>
  